export const injectStyles = () => {
    const css = `
.article-contributions-wrapper {
  display: flex;
  justify-content: flex-end;
}
    
.article-contributions-stats {
  display: flex;
  justify-content: flex-end;
  font-size: 12px;
  line-height: 24px;
  padding-bottom: 12px;
  margin-top: 6px;
  position: relative;
}
    
.article-contributions-stats__users {
  display: flex;
  padding-right: 5px;
  line-height: 0;
}
   
.article-contributions-stats__user:not(:first-child) {
  margin-left: -9px; 
}
.article-contributions-stats__user img {
  width: 24px;
  min-width: 24px;
  min-height: 24px;
  height: 24px;
  border: solid 2px var(--wds-avatar-border-color);
  border-radius: 100%;
}
    
.article-contributions-stats__tooltip {
  display: none;
  position: absolute;
  top: 100%;
  background-color: var(--theme-page-background-color--secondary);
  border: 1px solid var(--theme-border-color);
  color: var(--theme-page-text-color);
  z-index: 900;
  padding: 12px;
  width: 300px;
  font-size: 12px;
  line-height: 1.5;
  box-shadow: 0 0 12px 0 rgba(30, 12, 27, 0.3);
  border-radius: 3px;
  left: 50%;
  transform: translateX(-50%)
}
    
.article-contributions-stats__tooltip--force-display {
  display: block;
}
    
    
.article-contributions-stats__tooltip::before {
  border-color: transparent var(--theme-page-background-color--secondary) transparent transparent;
  border-style: solid;
  border-width: 14px 14px 14px 0;
  content: "";
  position: absolute;
  z-index: 1;
  transform: rotate(90deg) scale(70%);
  top: -18px;
  left: 50%;
}

.article-contributions-stats__tooltip::after {
  border-color: transparent var(--theme-page-background-color--secondary) transparent transparent;
  border-style: solid;
  border-width: 14px 14px 14px 0;
  content: "";
  position: absolute;
  transform: rotate(90deg) scale(70%);
  top: -19px;
  left: 50%;
}

.article-contributions-stats__tooltip::after {
  border-color: transparent var(--theme-border-color) transparent transparent;
  z-index: 0;
}
    
.article-contributions-stats__tooltip a {
  font-weight: bold !important;
}
    
.article-contributions-stats__tooltip p:not(:last-child) {
  padding-bottom: 12px;
}

.article-contributions-stats-toc {
	width: 100%;
	padding: 12px;
	display: flex;
	flex-direction: column;
	gap: 12px;
	justify-content: center;
	
	background-color: var(--theme-page-background-color--secondary);
    color: var(--theme-page-text-color);
    border-radius: 3px;
    font-size: 12px !important;
    line-height: 1.5;
    margin-bottom: 6px;
}

.article-contributions-stats-toc a {
  font-weight: bold !important;
}
.article-contributions-stats-toc .article-contributions-stats__contributions-stats {
	line-height: 24px;
}

.article-contributions-stats-toc__stats {
	display: flex;
	margin: 0 auto;
}

.article-contributions-stats-toc__sign-in-row {
	margin: 0 auto;
}
.article-contributions-stats-toc__sign-in-row p {
	margin-bottom: 0;
}

`;
    const styles = document.createElement('style');
    styles.appendChild(document.createTextNode(css));
    document.head.appendChild(styles);
};
